/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import selectIcon from "dc-icons/viewer2021/SDC_SelectObject_18_N.svg";
import { actionTags, supportedFileExtensions } from "constants/enums";
import * as stores from "stores";
import { modifyCursorApis } from "publicApis/OldPublicApis";
import { cursorType } from "constants/enums";

class SelectBootstrap extends Component {
  constructor() {
    super();
  }

  getLabel = () => getMessage("label.select");

  getIcon = () => selectIcon;

  getTooltip = () => getMessage("modernviewer.tooltip.select");

  getAriaLabel = () => getMessage("modernviewer.arialabel.select");

  getActionTags = () => [actionTags.LOCAL];

  getQuickTools = () => ["preview-select", "preview-pan"];

  getFileSelectionParams = () => ({
    acceptExtensions: Object.values(supportedFileExtensions),
    acceptConnectors: "all"
  });

  id = "preview-select";

  initializeAction = opts => {
    opts.showCallback(true);
  };

  exitCallback = () => new Promise((resolve, reject) => resolve());

  executeAction = opts => {
    const { executeCallback } = opts;
    executeCallback && executeCallback();
    modifyCursorApis(stores)
      .apiGetter()
      .resetCursor();
  };

  render() {
    return null;
  }
}

export default SelectBootstrap;
